module.exports = __webpack_public_path__ + "img/99.6.9a23cf7a.png";